import { useMutation } from "@tanstack/react-query";
import crashBundlesClient from "../../../api/crashBundles";

export const useRunAnalysisMutation = () =>
  useMutation({
    mutationFn: ({ fileKey, model }: { fileKey: string; model: string }) =>
      crashBundlesClient.runAnalysis(fileKey, model),
  });

export const useRequestBundleMutation = () =>
  useMutation({
    mutationFn: (clockId: string) => crashBundlesClient.requestBundle(clockId),
  });
